<template>
  <div class="add-user-visit">
    <form class="fc-form">
      <div class="fc-form-row">
        <vi-phone-number
          :number="phoneData"
          :prefix="phonePrefixData"
          @input="onPhoneNumberInput"
        />
        <span v-if="$v.phone.$error" class="form-error">Mobile Nummer ist erforderlich</span>
        <span v-else-if="serverError" class="form-error">{{ serverError }}</span>
      </div>
      <button
        class="fc-button"
        :disabled="!phoneData"
        @click.prevent="submitPhone">Registrieren
      </button>

      <!--      <div class="sub-label">-->
      <!--        <a href="/resend-qr-code">-->
      <!--          Re Send QR Code-->
      <!--        </a>-->
      <!--      </div>-->
    </form>
  </div>
</template>

<script>
import {getUserByPhone} from "../services/graphql";
import {required, minLength} from "vuelidate/lib/validators";
import ViPhoneNumber from "./ViPhoneNumber";

export default {
  name: "AddUserVisit",
  components: {ViPhoneNumber},
  data() {
    return {
      phone: null,
      phoneData: null,
      phonePrefixData: null,
      serverError: null,
    };
  },

  validations: {
    phone: {
      required,
      // minLength: minLength(6)
    }
  },

  methods: {
    submitPhone() {
      this.serverError = null;
      this.$v.phone.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      getUserByPhone(this.phone.trim())
        .then((user) => {
          this.$v.$reset();
          this.$emit('visitAdded')
        }).catch(err => {
        if (
          err.graphQLErrors &&
          err.graphQLErrors.length
        ) {
          if (err.graphQLErrors[0].message === "User not found") {
            this.$emit("userNotExist", this.phone);

          } else if (err.graphQLErrors[0].message) {
            this.$v.$reset();
            this.serverError = err.graphQLErrors[0].message;
          }
        }
      });
    },
    onPhoneNumberInput({prefix, number}) {
      this.serverError = null;
      this.phone = `${prefix}${number}`;
      this.phoneData = number;
      this.phonePrefixData = prefix;
    }
  }
};
</script>

<style lang="scss">
@import "AddUserVisit";
</style>
